import(/* webpackMode: "eager" */ "/home/devkrest/htdocs/devkrest.com/app/(pages)/case-studies/ev-charging-solution/page.tsx");
